import React from "react";
import { Col, Collapse, Row } from "antd";
import { DoubleRightOutlined } from "@ant-design/icons";
import CollapsePanel from "antd/es/collapse/CollapsePanel";
import classNames from "classnames";
import { wrap } from "../../helpers/array";

const header = (text: string, className?: string): React.ReactNode => (
  <div className={className}>{text}</div>
);

const dispatchWindowResize = (): void => {
  setTimeout(() => window.dispatchEvent(new Event("resize")), 500);
};

export interface CollapseHeaderProps {
  children?: React.ReactNode | React.ReactNode[];
  justifyContent?: "space-between" | "start";
  yGap?: number;
}

const CollapseHeader: React.FC<CollapseHeaderProps> = ({
  justifyContent = "space-between",
  yGap = 0,
  children,
}) => {
  return (
    <Collapse
      ghost
      expandIconPosition="right"
      className="collapse"
      expandIcon={({ isActive }) => (
        <DoubleRightOutlined rotate={isActive ? -90 : 90} />
      )}
      onChange={dispatchWindowResize}
      defaultActiveKey="0"
    >
      <CollapsePanel key="0" header={header("", "collapse-header")}>
        <div className={classNames("grid__filters", justifyContent)}>
          <Row style={{ rowGap: yGap }} gutter={15}>
            {wrap(children).map((component, index) => (
              <Col key={index.toString()}>{component}</Col>
            ))}
          </Row>
        </div>
      </CollapsePanel>
    </Collapse>
  );
};

export default CollapseHeader;
